<template>
    <Avatar :name="client.name" :avatar="client.avatar" :size="size"></Avatar>
</template>

<script>
import Avatar from "@components/Avatar.vue";
export default {
    name: "ClientAvatar",
    components: {
        Avatar,
    },
    props: {
        client: {
            type: Object,
            required: true,
        },
        size: {
            type: String,
            required: false,
            default: 'medium',
        }
    },
}
</script>

<style scoped>

</style>
